import __request__ from "routing/request";
export function system() {
  return __request__("GET", "/system", null, {}, {
    "Accept": ["application/json"]
  });
}
export function jvm() {
  return __request__("GET", "/system/jvm", null, {}, {
    "Accept": ["application/json"]
  });
}
export function locales() {
  return __request__("GET", "/system/locales", null, {}, {
    "Accept": ["application/json"]
  });
}
export function processBufferDump() {
  return __request__("GET", "/system/processbufferdump", null, {}, {
    "Accept": ["application/json"]
  });
}
export function threaddump() {
  return __request__("GET", "/system/threaddump", null, {}, {
    "Accept": ["application/json"]
  });
}
export function threadDumpAsText() {
  return __request__("GET", "/system/threaddump", null, {}, {
    "Accept": ["text/plain"]
  });
}
